import { render } from "./BreadCrumbs.vue?vue&type=template&id=ce011a3e"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js"

import "./BreadCrumbs.vue?vue&type=style&index=0&id=ce011a3e&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__